<script lang="ts">
import SectionEtablissementDocumentList from '@/generated/sections/SectionEtablissementDocumentList.vue';
import {storeDocument, storeDocumentType} from '@/generated/stores';
import Document, {DocumentDests} from '@/generated/classes/Document';
import DocumentType from '@/generated/classes/DocumentType';
import Route from '@/generated/classes/Route';
import {Modules, Sections} from '@/generated/classes/AppSchema';
import {CiRouter} from '@/framework/base/helpers/NavHelper';
import Etablissement from '@/generated/classes/Etablissement';
import {ObjTypes} from '@/generated/classes/ObjTypes';
import {FwkSections, RessourceFwkSection} from '@/ressources/globalRessources';
import {ColumnFilter, ListChoix} from '@/extend/classes/ListData';
import {defineComponent, type PropType} from "vue";
import Contrat from "@/extend/classes/Contrat.ts";
import ListData from "@/extend/classes/ListData.ts";
import Section from "@/framework/base/classes/Section.ts";
import SectionApprenti from "@/extend/sections/SectionApprentiExtend.vue";
import sectionImportDoc from "@/custom/sections/SectionImportDoc.vue";

export default defineComponent({
    components: {},
    extends: SectionEtablissementDocumentList,
    props: {
        etablissement: {
            type: Object as PropType<Etablissement>,
            required: true
        }
    },
    created(): void {
      this.setLastRoute();
      DocumentType.listType(new Document()).then((res) => {
        res.forEach((item) => {
          this.documentTypeIds.push(item.id);
        })
        this.defaultFilter();
        this.loadTable();
        this.isCreated = true;
      })
    },
    data() {
        const documentTypeIds: number[] = [];
        return {
          documentTypeIds,
          isCardView: true
        };
    },
    computed: {
      items(): unknown[] {
        if (!this.isCreated) {
          return this.listData.reccords;
        }
        if (this.route && this.route.sectionObjId != this.lastRoute.sectionObjId) {
          this.setLastRoute();
          this.loadTable();
        }
        return this.listData.reccords;
      },
      addLabel(): string {
          return RessourceFwkSection(FwkSections.NEW_DOCUMENT).label;
      },
      canAdd(): boolean {
          const foundTypeIds: number[] = [];
          this.items.forEach((item) => {
              const document = item as Document;
              if (!foundTypeIds.includes(document.typeId)) {
                  foundTypeIds.push(document.typeId);
              }
          })
          return (foundTypeIds.length != this.documentTypeIds.length);
      },
    },

    methods: {
        defaultFilter(): void {
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "etablissementId";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = this.etablissement.id;
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "categoryId";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = 9;
                choix.text = "Juridique"
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
        },
        canUpdate(document: Document): boolean {
            return true;
        },
        selectItem(event: any, row: any): void {
            const obj = row.item as Document;
            const route = new Route();
            route.module = Modules.DOCUMENT;
            route.sectionObjId = obj.id;
            route.section = Sections.DOCUMENT_VIEWER;
            route.isDialog = true;
            CiRouter.addRoute(route);
        },
        updateItem(item: unknown): void {
            const obj = item as Document;
            const route = new Route();
            route.isDialog = true;
            route.section = Sections.IMPORT_DOC;
            route.attribut = obj;
            CiRouter.addRoute(route);
        },
        addItem(): void {
            const document = storeDocument.createNewDocument();
            document.etablissementId = this.etablissement.id;
            document.objType = ObjTypes.ETABLISSEMENT;
            document.categoryId = 9;
            document.objId = this.etablissement.id;
            document.dest = DocumentDests.EMPLOYEUR;

            const route = new Route();
            route.isDialog = true;
            route.section = Sections.IMPORT_DOC;
            route.attribut = document;

            const section = new Section();
            section.component = sectionImportDoc;
            section.type = 'document';
            section.data = document;
            section.ressource = this.ressource;


            if (this.isAbstract) {
              this.$emit("openCrud", section);
            } else {
              CiRouter.addRoute(route);
            }

        },

        selectItemCard(item: any): void {
          const obj = item as Document;
          const route = new Route();
          route.module = Modules.DOCUMENT;
          route.sectionObjId = obj.id;
          route.section = Sections.DOCUMENT_VIEWER;
          route.isDialog = true;
          CiRouter.addRoute(route);
        },
        getInitials(value: any): string {
          const name = storeDocumentType.getDocumentType(value.typeId);
          const initials = name.label.split(/[ -]+/);
          if (initials.length > 1) {
            return initials[0][0] + initials[initials.length - 1][0];
          } else {
            return initials[0][0] + initials[0][1];
          }
        },
        getTitle(value: any): string {
          const res = storeDocumentType.getDocumentType(value);
          return res.label;
        },
        getNewLabel() : string {
          return "Aucun document n’est renseigné";
        },
    }
})

</script>
